import type { AddressParam } from "types/api/addressParams";

export const ADDRESS_HASH = "0x2B51Ae4412F79c3c1cB12AA40Ea4ECEb4e80511a";

export const ADDRESS_PARAMS: AddressParam = {
  hash: ADDRESS_HASH,
  implementations: null,
  is_contract: false,
  is_verified: null,
  name: null,
  private_tags: [],
  public_tags: [],
  watchlist_names: [],
  ens_domain_name: null,
};
